import { REASON_LABEL } from './labels';

/** Spanish messages for the error codes raised by the voting functions */

const MESSAGES: Record<string, string> = {
  not_authorized: 'No tienes permiso para esta acción.',
  election_not_found: 'No se encontró la elección.',
  election_closed: 'La elección ya está cerrada.',
  election_has_open_round: 'Hay una ronda abierta en esta elección. Ciérrala primero.',
  election_already_started: 'La elección ya empezó: no se puede cambiar el evento ni el modo.',
  ranked_mode_not_available: 'El modo por ranking aún no está disponible.',
  position_not_found: 'No se encontró el cargo.',
  position_filled: 'El cargo ya tiene ganador.',
  position_has_active_round: 'El cargo ya tiene una ronda sin cerrar.',
  winner_pending_confirmation: 'Confirma el ganador de la ronda anterior antes de crear otra.',
  not_enough_candidates: 'Se necesitan al menos 2 candidatos.',
  candidate_invalid: 'Algún candidato no está disponible (retirado, ya elegido o fuera de la ronda).',
  race_not_found: 'No se encontró la ronda.',
  race_not_draft: 'La ronda ya no está en borrador.',
  race_not_open: 'La ronda no está abierta.',
  race_closed: 'La ronda ya está cerrada.',
  race_has_no_winner: 'La ronda no tiene un ganador por confirmar.',
  winner_already_confirmed: 'El ganador ya fue confirmado.',
  note_required: 'Escribe el motivo de la corrección.',
  vote_not_found: 'Esa persona no votó en esta ronda.',
  blank_not_allowed: 'Esta ronda no permite voto en blanco.',
  manual_voters_need_election_without_event:
    'Los votantes manuales solo se usan en elecciones sin evento. En un evento, inscríbelos como invitados.',
  voter_name_required: 'Escribe el nombre completo del votante.',
  session_expired: 'Su sesión venció. Ingrese de nuevo con su CI y PIN.',
  already_voted: 'Esta persona ya votó en esta ronda.',
  identity_not_verified: 'Confirma que verificaste el CI de la persona.',
  voter_not_found: 'No se encontró al votante.',
  voter_reference_invalid: 'Votante no válido.',
  checkin_closed: 'La votación ya empezó: se cerró el registro de votantes.',
  voter_ci_required: 'Escribe el CI del votante.',
};

const RAW_CONSTRAINTS: [RegExp, string][] = [
  [/election_voters_manual_ci_unique/, 'Ya existe un votante con ese CI en esta elección.'],
  [/violates foreign key constraint/, 'No se puede quitar: ya participa en una ronda. Retíralo en su lugar.'],
  [/election_candidates_unique/, 'Ese ministro ya es candidato.'],
  [/elections_attendance_needs_event/, 'Para exigir asistencia, elige un evento.'],
  [/elections_session_rule_check/, 'Para exigir asistencia a una sesión, elige la sesión.'],
];

export function votingErrorMessage(err: unknown): string {
  const raw = err instanceof Error ? err.message : typeof err === 'object' && err && 'message' in err ? String((err as { message: unknown }).message) : String(err);
  const [code, detail] = raw.split('|').map((x) => x.trim());
  if (code === 'voter_not_eligible') return REASON_LABEL[detail] ?? 'La persona no puede votar.';
  if (MESSAGES[code]) return MESSAGES[code];
  for (const [re, msg] of RAW_CONSTRAINTS) if (re.test(raw)) return msg;
  return raw || 'Ocurrió un error inesperado.';
}
